type Props = {
  size?: "sm" | "md" | "lg";
  label?: string;
};

export function Spinner({ size = "md", label }: Props) {
  const dimension = size === "sm" ? "h-4 w-4" : size === "lg" ? "h-8 w-8" : "h-5 w-5";
  return (
    <div className="flex items-center gap-3 text-white/60" role="status" aria-live="polite">
      <svg
        className={`animate-spin ${dimension} text-forja-orange`}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeOpacity="0.25"
          strokeWidth="3"
        />
        <path
          d="M22 12a10 10 0 0 1-10 10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}

export function SkeletonBar({ className = "" }: { className?: string }) {
  return (
    <div
      className={`bg-white/5 rounded-md animate-pulse-soft ${className}`}
      style={{ height: "1rem" }}
    />
  );
}
